import { Dispatch, FC, SetStateAction } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import { useExternalModal } from 'ui/partials/Modal/useModal';

import SimpleCompanyForm from '../forms/SimpleCompanyForm';
import {
  COMPANY_FORM,
  SIMPLE_COMPANY_FORM,
  SIMPLE_COMPANY_SCHEMA,
} from '../forms/schema';
import useCreateCompany from '../hooks/useCreateCompany';

interface PROPS {
  setForm: Dispatch<SetStateAction<any>>;
}

const FORM_INIT = {
  name: '',
  industry: '',
  type: '',
} as SIMPLE_COMPANY_FORM;

const CreateSimpleCompanyModal: FC<PROPS> = ({ setForm }) => {
  const { hideModal } = useExternalModal();
  const { mutate: addCompany } = useCreateCompany(true);

  const onSubmit = (
    values: SIMPLE_COMPANY_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_COMPANY_FORM>,
  ) => {
    addCompany(values as COMPANY_FORM, {
      onSuccess: () => {
        hideModal();
      },
      onSettled: ({ data }: any) => {
        setForm((prevState: any) => ({ ...prevState, companyId: data._id }));

        setSubmitting(false);
      },
      onError: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_COMPANY_SCHEMA}
    >
      {() => <SimpleCompanyForm onCancel={hideModal} />}
    </Formik>
  );
};

export default CreateSimpleCompanyModal;
